import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getUrlParams } from "../apiService/timespam";
import { lifestyleApi } from "../apiService/api";
import "./Theme.css";
import "./ScoradDashboard.css";

const getDifficultyLevel = (score) => {
  const s = parseFloat(score || 0);
  if (s < 25) return { text: "Mild", color: "#4cd964" };
  if (s < 50) return { text: "Moderate", color: "#ffcc00" };
  return { text: "Severe", color: "#ff3b30" };
};

const ScoradDashboard = () => {
  const { t } = useTranslation();
  const { theme, lang } = getUrlParams();

  const [scoreList, setScoreList] = useState([]);
  const [selectedScore, setSelectedScore] = useState(null);
  const [signSymptoms, setSignSymptoms] = useState(null);
  const [showDetail, setShowDetail] = useState(false);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const PAGE_SIZE = 7;

  useEffect(() => {
    document.documentElement.className = theme === "dark" ? "dark" : "";
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [theme, lang]);

  useEffect(() => {
    lifestyleApi.fetchScoradScore()
      .then((res) => {
        const scores = res.data.data?.scoradScore || [];
        const latestByDate = scores.reduce((acc, cur) => {
          const d = cur.logDate;
          if (!acc[d] || new Date(cur.lastUpdatedTime) > new Date(acc[d].lastUpdatedTime)) acc[d] = cur;
          return acc;
        }, {});
        setScoreList(Object.values(latestByDate).sort((a, b) => new Date(b.logDate) - new Date(a.logDate)));
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const handleViewDetail = async (scoreItem) => {
    setSelectedScore(scoreItem);
    try {
      const res = await lifestyleApi.fetchSignSymptomsScore({ scoreId: scoreItem.scoreId });
      setSignSymptoms(res.data.data || null);
    } catch (err) {
      // fetchSignSymptomsScore error
    }
    setShowDetail(true);
  };

  const paged = scoreList.slice(page * PAGE_SIZE, (page + 1) * PAGE_SIZE);

  if (loading) return <div className="sdb-loading">{t("common.loading")}</div>;

  return (
    <section className="sdb-page">
      {showDetail && selectedScore && (
        <div className="sdb-modal-overlay" onClick={() => setShowDetail(false)}>
          <div className="sdb-modal" onClick={(e) => e.stopPropagation()}>
            <button className="sdb-modal-close" onClick={() => setShowDetail(false)}>✕</button>
            <h2 className="sdb-modal-title">SCORAD Detail</h2>
            <div className="sdb-modal-row"><span>Date:</span><span>{selectedScore.logDate}</span></div>
            <div className="sdb-modal-row"><span>BSA:</span><span>{selectedScore.bsaScore}</span></div>
            <div className="sdb-modal-row"><span>IO Sign:</span><span>{signSymptoms?.ioSignScore ?? "--"}</span></div>
            <div className="sdb-modal-row"><span>IO Symptom:</span><span>{signSymptoms?.ioSymptomScore ?? "--"}</span></div>
            <div className="sdb-modal-row"><span>SCORAD:</span><span>{selectedScore.scoradScore}</span></div>
          </div>
        </div>
      )}

      {scoreList.length === 0 ? (
        <p className="sdb-empty">{t("scoradDetails.noData")}</p>
      ) : (
        <>
          <div className="sdb-page-nav">
            <button className="sdb-nav-btn" disabled={page === 0} onClick={() => setPage((p) => p - 1)}>&#8249;</button>
            <span className="sdb-page-label">{t("scoradDetails.page")} {page + 1}</span>
            <button className="sdb-nav-btn" disabled={(page + 1) * PAGE_SIZE >= scoreList.length} onClick={() => setPage((p) => p + 1)}>&#8250;</button>
          </div>
          {paged.map((item, i) => {
            const diff = getDifficultyLevel(item.scoradScore);
            return (
              <div key={i} className="sdb-score-card" onClick={() => handleViewDetail(item)}>
                <div className="sdb-score-info">
                  <span className="sdb-score-date">{item.logDate}</span>
                  <span className="sdb-score-diff" style={{ color: diff.color }}>{diff.text}</span>
                </div>
                <span className="sdb-score-val">{item.scoradScore}</span>
              </div>
            );
          })}
        </>
      )}
    </section>
  );
};

export default ScoradDashboard;
